import * as React from "react";

import { Skeleton as PrimitiveSkeleton } from "../../primitive/skeleton";

export type SkeletonProps = React.ComponentProps<typeof PrimitiveSkeleton>;

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (props, ref) => {
    return <PrimitiveSkeleton ref={ref} {...props} />;
  },
);

Skeleton.displayName = "Skeleton";
